import { ChatItemModel } from './chat-item.model';

export enum ChatType {
  Requests,
  Enquiries,
  Messages,
}

export enum ChatStatus {
  Rejected = 0,
  Approved = 1,
  Requested = 2,
  Feedback = 3,
}

export class ChatModel {
  constructor(
    public id: string,
    public title: string,
    public isRead: boolean,
    public type: ChatType,
    public items: ChatItemModel[]
  ) {}
}
